import { IconButton } from "@mui/material";
import { Trash } from "iconsax-react";

interface IDeleteActionProps {
  handleDelete: () => void;
  disabled?: boolean;
}

export default function DeleteAction({
  handleDelete,
  disabled,
}: Readonly<IDeleteActionProps>) {
  return (
    <IconButton
      disabled={disabled}
      onClick={handleDelete}
      sx={{
        padding: "4px",
        borderRadius: "50%",
        width: "fit-content",
        cursor: "pointer",
        // mx: "auto",
        display: disabled ? "none" : "block",
        "&:hover": {
          color: (theme) => theme.palette.others.deadline,
          // backgroundColor: "var(--satisfaction-60)",
        },
      }}
    >
      <Trash size="18" />
    </IconButton>
  );
}
